import {
  generateReactKey,
  KeyRoots,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';
import { TimesheetsTableFooter } from '../Cells/TimesheetsTableFooterCell';
import { DaysForecastedHours } from '../utils/getForecasteHours';
import { TableRowFooter } from './styles/TimesheetsFooterRow.styled';

interface TimeSheetsFooterRowProps {
  data: string[];
  forecastedHours: DaysForecastedHours[];
}

export const TimeSheetsFooterRow = ({
  data,
  forecastedHours,
}: TimeSheetsFooterRowProps) => {
  return (
    <TableRowFooter>
      {data.map((cell, index) => {
        if (index === 0) {
          return (
            <TimesheetsTableFooter
              data={cell}
              index={index}
              key={generateReactKey(
                KeyRoots.TIME_SHEET_DESKTOP_FOOTER_CELL,
                index
              )}
            />
          );
        }
        return (
          <TimesheetsTableFooter
            data={cell}
            dayForecastedHours={
              index === 8
                ? forecastedHours[index - 1].totalWeekHours
                : forecastedHours[index - 1].dayOfweek
            }
            dayForcastedType={
              index === 8
                ? forecastedHours[index - 1].totalWeekType
                : forecastedHours[index - 1].dayOfWeekType
            }
            index={index}
            key={generateReactKey(
              KeyRoots.TIME_SHEET_DESKTOP_FOOTER_CELL,
              index
            )}
          />
        );
      })}
    </TableRowFooter>
  );
};
